import classNames from "classnames";
import { BaseSyntheticEvent, KeyboardEvent, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { ReportsType } from "..";
import { calcPeriod, formatCode, formatValue, getReports, ROWS } from "../utils";

type Props = {
  prefix: string;
};

export const TBody = ({ prefix }: Props) => {
  const { getValues, setValue } = useFormContext();
  const [reports, setReports] = useState<ReportsType>(getReports(getValues(prefix)));

  useEffect(() => {
    setValue(`${prefix}.reports`, reports);
  }, []);

  const onChangeCell = (reportKey: string, dataKey: string, config) => (e: BaseSyntheticEvent) => {
    let fixedValue = e.target.value.replace(/[,.]/g, "");
    fixedValue.length > 10 && (fixedValue = fixedValue.slice(0, 11));

    const value = config.negative ? -Math.abs(Number(fixedValue)) : Number(fixedValue);

    setReports((prevReports) => {
      const newReports = { ...prevReports };
      newReports[reportKey] = calcPeriod({
        ...newReports[reportKey],
        [dataKey]: isFinite(value) && fixedValue !== "" ? value : undefined,
      });

      setValue(`${prefix}.reports.${reportKey}`, newReports[reportKey]);
      return newReports;
    });
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "e" || e.key === "E") {
      e.preventDefault();
    }
  };

  const onWheel = (e: BaseSyntheticEvent) => {
    e.target.blur();
  };

  return (
    <div className="buh-table-content">
      {ROWS.map((row, idx) => (
        <div
          key={row.title + idx}
          className={classNames("table-row", { full: row.merge, bold: row.bold })}
        >
          <div className="cell">{row.title}</div>
          {row.dataKey && <div className="cell code">{formatCode(row.dataKey)}</div>}
          {!row.merge &&
            row.dataKey &&
            Object.entries(reports).map(([key, report]) => (
              <>
                {!row.summary ? (
                  <label key={`${key}-${row.dataKey}`} className="cell">
                    <div>
                      <span>{formatValue(report[row.dataKey], row.negative)}</span>
                      <input
                        type="number"
                        value={report[row.dataKey]}
                        onChange={onChangeCell(key, row.dataKey, {
                          negative: row.negative,
                        })}
                        onKeyDown={onKeyDown}
                        onWheel={onWheel}
                      />
                    </div>
                  </label>
                ) : (
                  <span className="cell summary">
                    {formatValue(report[row.dataKey], row.negative)}
                  </span>
                )}
              </>
            ))}
        </div>
      ))}
    </div>
  );
};
